<template>
	<div id="group-with-loading" class="px-6 pb-2 pt-6">
		<form v-if="OptimizationUpdatePermission" class="form-content p-1">
			<div class="vx-row w-full">
				<div class="vx-col w-full mt-4">
					<div class="vx-row mb-10">
						<div class="vx-col w-full">
							<label class="date-label">{{ $t("Name") }}</label>
							<vs-input
								v-model="optimization.name"
								class="mt-5 w-full"
								name="item-name"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('item-name')">{{
								$t("BreakForm.ValidMessages.Name")
							}}</span>
						</div>
					</div>
					<div class="vx-row mb-6">
						<div class="vx-col w-full">
							<label class="date-label">{{ $t("Group.OptimizationGroup") }}</label>
							<v-select
								v-model="optimization.group"
								:clearable="false"
								:options="activityOptions"
								v-validate="'required'"
								name="role"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
					</div>
				</div>
			</div>
			<div class="vx-row p-1">
				<div class="vx-col w-full flex justify-end items-center">
					<vs-button color="danger" class="mr-3 mb-2" @click.prevent="closeSidebar()"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button class="mr-3 mb-2" @click.prevent="update()">{{ $t("Crud.Update") }}</vs-button>
				</div>
			</div>
		</form>
		<not-permission v-else></not-permission>
	</div>
</template>

<script>
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import NotPermission from "@/views/pages/NotPermission.vue";
import vSelect from "vue-select";

export default {
	name: "OptimizationForm",
	props: {
		isEditActive: {
			type: Boolean,
			required: false,
		},
		data: {
			type: Object,
		},
	},
	components: {
		vSelect,
		NotPermission,
	},
	data() {
		return {
			optimization: {name: this.data.name, group: {}},
			groupOptimizationList: [],
			selectedGroupOptimization: {label: "", value: ""},
		};
	},
	computed: {
		activityOptions() {
			return this.groupOptimizationList.map((el) => {
				return {value: el.id, label: el.name};
			});
		},
		OptimizationUpdatePermission() {
			return this.$store.getters.checkPermission("OPTIMIZATION_U");
		},
	},
	async mounted() {
		await this.getGroupsOptimizations();
	},
	created() {
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	methods: {
		update() {
			let params = {
				name: this.optimization.name,
				optimization_group_id: this.optimization.group.value,
			};
			this.$store
				.dispatch("moduleOptimization/update", {id: this.data.id, items: params})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Group.Messages.TitleConfirmUpdate"),
						text: this.$t("Group.Messages.TextConfirmUpdate"),
					});
					this.$vs.loading.close();
					this.$emit("showSidebarEdit", false);
					this.$emit("refreshList");
					this.$validator.reset();
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		closeSidebar() {
			this.$emit("showSidebarEdit", false);
		},
		async getGroupsOptimizations() {
			await this.$store.dispatch("moduleOptimizationGroup/findAll").then((res) => {
				this.groupOptimizationList = res["data"];
				res.data.find((group) => {
					if (group.id === this.data.optimization_group_id)
						this.optimization.group = {label: group.name, value: group.id};
				});
				return res;
			});
		},
	},
};
</script>
